import React, { Component } from 'react'
import PropTypes from 'prop-types'

import CSSModules from 'react-css-modules'
import styles from './styles.scss'

const StatusColorHoc = (props, Component) => {
  let {
    state
  } = props

  switch (state) {
  case 'Rejected': return <Component {...props} styleName='reject'/>
  default: return <Component {...props} styleName='approve'/>
  }
}

export default CSSModules(StatusColorHoc, styles)
